export enum ActivitiesTabPages {
  Applications = 0,
  Activities = 1,
}
